import { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import { customerLookalikes } from "@/api";
import { FileInfo } from "@/types";

const useCustomerLookalikes = () => {
  const { getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const exportLookalikes = async (
    fileInfo: FileInfo | null,
    exportOption: string,
    segment?: string
  ) => {
    setLoading(true);
    setError(null);

    if (!fileInfo) return setError("No file info provided");

    try {
      const accessToken = await getAccessTokenSilently();
      const { data, error } = await customerLookalikes(
        accessToken,
        fileInfo,
        exportOption,
        segment
      );
      if (error) {
        setError(error.message);
      } else {
        return data;
      }
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setLoading(false);
    }
  };

  return { exportLookalikes: exportLookalikes, loading, error };
};

export default useCustomerLookalikes;
